<script>
  export default {
    props: {
      message: Object,
      contact: Object,
      outgoingNumber: Object,
      brand: Object,
      settings: Array,
    },

    methods: {
      /**
       * @param {Object|null} date
       * @return {String|null}
       */
      formatTime(date) {
        return date
          ? moment(date.iso).format('ddd, MMM D, YYYY ') + date.time
          : null;
      },
    },
  }
</script>
